import { render, staticRenderFns } from "./InvoicesBulkCreation.vue?vue&type=template&id=2ad89018&scoped=true"
import script from "./InvoicesBulkCreation.vue?vue&type=script&lang=js"
export * from "./InvoicesBulkCreation.vue?vue&type=script&lang=js"
import style0 from "./InvoicesBulkCreation.vue?vue&type=style&index=0&id=2ad89018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad89018",
  null
  
)

export default component.exports